import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from './ui/button';

export function EmptyState({ 
    icon: Icon,
    title, 
    description, 
    actionLabel, 
    onAction,
    className 
}) {
    return (
        <div className={cn(
            "flex flex-col items-center justify-center text-center px-6 py-16",
            className
        )}>
            {Icon && (
                <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-muted-foreground" />
                </div>
            )}
            
            <h3 className="font-semibold text-foreground mb-1">
                {title}
            </h3>
            
            <p className="text-sm text-muted-foreground max-w-[260px] mb-5">
                {description}
            </p>
            
            {actionLabel && onAction && (
                <Button onClick={onAction}>
                    {actionLabel}
                </Button>
            )}
        </div>
    );
}
